module.exports = __webpack_public_path__ + "media/images/mobile/abouts/13-ec0bf60d3b08876f12679f52ace36457.jpg";